<template>
  <section>
    <div class="subscribe-section">
      <h2 class="section-title">{{ section.title }}</h2>

      <subscribe-form
        :subscribed-redirect-u-r-l="$t('footerWide.subscribedURL')"
        :subscribe-source="$t('footerWide.subscribeSource')"
      />
    </div>
  </section>
</template>

<script>
  import SubscribeForm from 'components/Forms/Subscribe'

  export default {
    name: "SubscribeSection",
    components: {
       SubscribeForm
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .subscribe-section {
    display: flex;
    flex-direction: column;
    padding: 36px 16px;
    background: $blue-bg-darker;
    border-radius: 6px;
  }

  .section-title {
    @include defaultFontValues($blue-dark, 24, 32, 500);
    margin: 0 0 16px;

    @include bp-mf-tablet {
      text-align: center;
      line-height: 24px;
      margin-bottom: 30px;
    }
  }

</style>
